<template>
  <header class="topHeader">
    <!-- 배너 -->
    <!-- <div id="band_banner">
      <div class="band_banner" style="background: #11223c" v-if="topBannerShow">
        <div class="inner_band_banner">
          <a href="https://blog.naver.com/donghanglottery1004/223510099833?trackingCode=blog_bloghome_searchlist" target="_blank" class="img_banner"
            ><img src="@/assets/images/dhb/1731481767436.jpg" alt="" /></a
          ><a class="btn_close" href="javascript:;" @click="closePopup">하루 동안 보지 않기</a>
        </div>
      </div>
    </div> -->

    <div class="header_con">
      <div class="logo">
        <h1><router-link to="/">동행복권</router-link></h1>
      </div>
      <div class="top_menu">
        <form name="frmLogin">
          <div class="topAccount" v-if="this.$store.state.isAuthenticated">
            <ul class="information">
              <li>
                <span class="user_info"
                  ><strong>
                    {{ this.$store.state.info.iu_name }}({{
                      this.$store.state.info.iu_nick_name
                    }})
                  </strong></span
                >
              </li>
              <li class="money">
                <span>예치금</span>
                <router-link to="/myPage.do?method=depositListView"
                  ><strong
                    >{{
                      this.$comma(this.$store.state.info.iu_balance)
                    }}원</strong
                  ></router-link
                >
                <router-link
                  to="/payment.do?method=payment"
                  class="btn_common sml"
                  >충전</router-link
                >
                <router-link
                  to="/userSsl.do?method=refundView"
                  class="btn_common sml"
                  >출금</router-link
                >
              </li>
            </ul>
            <ul class="account">
              <li class="log devide">
                <a class="btn_common sml" @click="logout()">로그아웃</a>
              </li>
              <li>
                <router-link
                  class="btn_common sml gblu"
                  to="/userSsl.do?method=myPage"
                  >마이페이지</router-link
                >
              </li>
              <li>
                <router-link
                  class="btn_common sml gblu"
                  to="/counsel.do?method=callCenter"
                  >고객센터</router-link
                >
              </li>
              <li v-if="this.$store.state.info.iu_is_access_chongpan">
                <router-link
                  class="btn_common sml gblu"
                  :to="{ name: 'PartnerMember' }"
                  >파트너</router-link
                >
              </li>
            </ul>
          </div>
          <div class="topAccount" v-else>
            <ul class="account">
              <li class="log">
                <router-link class="btn_common sml" to="/user.do?method=login"
                  >로그인</router-link
                >
              </li>
              <li class="devide">
                <router-link
                  class="btn_common sml blu"
                  to="/loginJoin.do?method=joinFormAgree"
                  >회원가입</router-link
                >
              </li>
              <li>
                <router-link class="btn_common sml gblu" to="/"
                  >마이페이지</router-link
                >
              </li>
              <li>
                <router-link class="btn_common sml gblu" to="/"
                  >고객센터</router-link
                >
              </li>
            </ul>
          </div>
        </form>
      </div>
    </div>
  </header>

  <div class="nav_wrap" style="z-index: 999">
    <nav class="gnbNav">
      <div id="gnb" class="gnb">
        <ul>
          <!-- <li class="gnb1"><a href="/gameBuy.do?method=gameBuyHome"></a></li> -->
          <li class="gnb1">
            <router-link :to="{ name: 'Powerball' }">복권구매</router-link>
            <div class="group">
              <ul>
                <li class="gnb1_1">
                  <router-link :to="{ name: 'Game645' }" title="새창 열림"
                    ><strong>로또 6/45</strong
                    ><span
                      >매주 토요일 추첨<br />6개 숫자 직접 선택</span
                    ></router-link
                  >
                </li>

                <li class="gnb1_2">
                  <router-link :to="{ name: 'Powerball' }" title="파워볼"
                    ><strong>파워볼</strong
                    ><span
                      >5분마다 추첨<br />최고당첨금 3억원</span
                    ></router-link
                  >
                </li>
              </ul>
            </div>
          </li>
          <li class="basic gnb2">
            <router-link to="/">복권정보</router-link>
          </li>
          <li class="basic gnb3">
            <router-link to="/">당첨결과</router-link>
          </li>
          <li class="basic gnb4">
            <router-link to="/">판매점</router-link>
          </li>
          <li class="basic gnb5">
            <router-link to="/service.do?method=eventList&wiselog=C_C_1_2"
              >이벤트</router-link
            >
          </li>
          <li class="basic gnb6">
            <router-link to="/">행복공감</router-link>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<style lang="scss">
.user_info {
  font-size: medium;
  display: flex;
  align-items: center;
  margin-top: 2px;
  img {
    width: 20px;
    margin-right: 5px;
  }
}
</style>

<script>
export default {
  components: {},
  data() {
    return {
      notificationCount: 0,
      remainCoupons: 0,
      now: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
      topBannerShow: true,
    };
  },
  mounted() {
    setTimeout(() => {
      this.getNotificationCount();
    }, 2000);

    this.getMyInformation();
    this.loginCheck();
    setInterval(() => {
      this.getNotificationCount();
      this.getMyInformation();
    }, 10000);

    setInterval(() => {
      this.loginCheck();
    }, 3000);

    setInterval(() => {
      this.now = this.$moment().format("YYYY-MM-DD HH:mm:ss");
    }, 1000);

    if (this.$cookies.get("topBanner")) {
      this.topBannerShow = false;
    }
  },
  methods: {
    closePopup() {
      this.$cookies.set("topBanner", true);
      this.topBannerShow = false;
    },
    logout() {
      this.$store.dispatch("logout", {}).catch(({ message }) => alert(message));
    },
    getBalanceInformation() {
      if (this.$store.state.isAuthenticated) {
        this.$store.dispatch("getBalance");
      }
    },
    getMyInformation() {
      if (this.$store.state.isAuthenticated) {
        this.$store.dispatch("getInfo");
      }
    },
    getNotificationCount() {
      if (this.$store.state.isAuthenticated) {
        this.$axios.get("/web/my/notification/count", {}).then((res) => {
          this.notificationCount = res.data.count;
          if (res.data.count > 0 && this.$route.name !== "Message") {
            this.$alert(this.$t("alert.unreadMessage"));
            this.$router.push({ name: "Message" });
          }
        });
      }
    },
    getCouponsCount() {
      if (this.$store.state.isAuthenticated) {
        this.$axios.get("/web/coupons/remain", {}).then((res) => {
          this.remainCoupons = res.data.remain;
        });
      }
    },
    exchangePoint() {
      this.$confirm(
        this.$t("alert.exchangePoint"),
        this.$t("alert.exchangePointTitle")
      ).then(() => {
        this.$axios
          .post("/web/my/point", {})
          .then((res) => {
            this.$alert(res.data.message);
            this.$store.dispatch("getInfo");
          })
          .catch((err) => this.$alert(err.response.data.message));
      });
    },
    loginCheck() {
      if (this.$store.state.isAuthenticated) {
        this.$axios
          .get("/web/check/login")
          .then((res) => {})
          .catch((err) => {
            // this.$alert(err.response.data.message);
          });
      }
    },
  },
};
</script>
